import { motion } from "framer-motion";
import { useMemo } from "react";
import "./css/celebration.css";

const CelebrationBomb = ({
  message = "¡Excelente progreso!",
  intensity = 40,
  duration = 2.5,
  size = "md",
}) => {
  const particles = useMemo(
    () =>
      Array.from({ length: intensity }).map(() => ({
        x: Math.random() * 600 - 300,
        y: Math.random() * -400,
        rotate: Math.random() * 360,
      })),
    [intensity],
  );

  return (
    <div className="celebration-wrapper">
      {particles.map((p, i) => (
        <motion.span
          key={i}
          className="particle"
          initial={{ opacity: 1, scale: 0 }}
          animate={{
            opacity: 0,
            scale: 1.6,
            x: p.x,
            y: p.y,
            rotate: p.rotate,
          }}
          transition={{ duration }}
        />
      ))}

      <motion.div
        className={`celebration-text celebration-${size}`}
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 180 }}
      >
        {message}
      </motion.div>
    </div>
  );
};

export default CelebrationBomb;
